import axios from "axios";
import { retry } from "ts-retry-promise";

import { logger } from "@/services/logger";

export async function getPublicIP() {
  try {
    const res = await retry(async () => await axios.get<{ ip: string }>("https://api.ipify.org?format=json"), {
      retries: 3,
      timeout: 2000,
    });
    return res.data.ip;
  } catch (e) {
    logger.error("Unable to get public IP", { e });
    return undefined;
  }
}

export async function getCountryCode(ip?: string) {
  try {
    const url = ip ? `https://api.country.is/${ip}` : "https://api.country.is";
    const res = await retry(async () => await axios.get<{ country: string }>(url), {
      retries: 3,
      timeout: 2000,
    });
    return res.data.country;
  } catch (e) {
    logger.error("Unable to get country code", { e });
    return undefined;
  }
}
